/* ============
 * State of vivemas module
 * ============
 *
 * The initial state of the vivemas module.
 */

export default {
  assistCategories: [],
  benefitCategories: [],
  benefits: [],
  assists: [],
  brands: [],
  cities: []
}



// WEBPACK FOOTER //
// ./src/store/modules/vivemas/state.js